import PropTypes from 'prop-types';
import TrainerSocialAction from './TrainerSocialAction';

const propTypes = {
  email: PropTypes.string.isRequired,
};

export default function TrainerSocialEmail({ email }) {
  return (
    <TrainerSocialAction url={`mailto:${email}`}>
      Enviar mensaje
    </TrainerSocialAction>
  );
}

TrainerSocialEmail.propTypes = propTypes;
